'use client'

import Avatar from '@component/avatar'
import SectionSwiper from '@component/layout/section/swiper'
import Tooltip from '@component/tooltip'
import useConfirm from '@hooks/useConfirm'
import getRouter, { URLS } from '@router'
import { getTime } from '@utils'
import { get, replace } from 'lodash-es'
import Image from 'next/image'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { useCallback, useMemo } from 'react'

export default function PropertyHistory({
  data
}) {

  return (
    <div className='p-12 sm:px-20 border sm:border-0'>
      <SectionSwiper
        data={data}
        Card={PropertyHistoryCard}
        showNext={false}
        slidesPerView='auto'
        slidesPerGroup={1}
        breakpoints={{}}
        slideClassName='!w-auto'
      ></SectionSwiper>
    </div>
  )
}

function PropertyHistoryCard({ data }) {

  const { openConfirm } = useConfirm()

  const label = useMemo(() => {
    let res = data.consentTitle || data.label || data.labelValue
    if (res) res = replace(res, /Property sold/g, 'Sold')
    return res
  }, [data])
  const agent = useMemo(() => get(data, 'agents.0'), [data])
  const office = useMemo(() => get(data, 'office'), [data])

  const openConsentRef = useCallback(() => {
    openConfirm({
      content: (
        <div className='text-left'>
          <div className='text-lg text-font'>{data.consentTitle}</div>
          <div className='mt-8 text-neutral-5 text-base'>{data.consentRef}</div>
          <div className='mt-16 text-font text-sm'>{data.labelValue}</div>
        </div>
      ),
      contentClassName: '!pt-0 !pb-30',
      useButton: false
    })
  }, [data, openConfirm])

  return (
    <div className='p-16 border rounded overflow-hidden h-205 flex flex-col justify-between items-start relative w-240'>
      {
        office && office.icon && (
          <Image src={office.icon} width={120} height={30} alt={office.name} className='absolute object-contain object-right-top right-0 top-0 rounded-tr'></Image>
        )
      }
      {
        agent && (
          <div className='absolute right-10 top-40 flex flex-col items-end gap-y-4'>
            <Avatar src={agent.icon} width={65} height={65} alt={agent.name} className='rounded-sm'></Avatar>
            <div className='text-sm text-font'>{agent.name}</div>
            <div className='text-xs text-neutral-5'>{agent.jobTitle}</div>
          </div>
        )
      }
      <div>
        <div className='text-base font-medium text-secondary'>{getTime(data.labelTime, 'MMM')}</div>
        <div className='text-3xl text-font font-bold mt-10'>{getTime(data.labelTime, 'YYYY')}</div>
      </div>
      {
        data.saleType && (
          <Tooltip bottom content={<div className='whitespace-nowrap px-8 py-4 rounded-sm'>{data.saleTypeDes}</div>}>
            <DisablePrefetchLink href={getRouter(URLS.salesType)} target='_blank' className='text-xs text-primary'>{data.saleType}</DisablePrefetchLink>
          </Tooltip>
        )
      }
      {
        label && (
          <span className='text-font text-lg font-medium'>{label}</span>
        )
      }
      {data.consentRef && <div className='text-xs text-primary cursor-pointer mt-8' onClick={openConsentRef}>View</div>}
    </div>
  )
}